/**
 * Decisiones de presentación del modal de cobro (testeables sin render).
 */

export type PriceListPresentation = 'hidden' | 'chips' | 'picker';

/**
 * Cuántas listas activas hay y si alguna está seleccionada define la UI:
 * - 0 listas o 1 sola sin seleccionar → no hay nada que decidir, se oculta.
 * - Pocas opciones (con «Sin lista» ≤ 5) → chips compactos.
 * - Muchas → selector con buscador.
 */
export function resolvePriceListPresentation(
  listCount: number,
  hasActiveSelection: boolean,
  chipOptionLimit = 5,
): PriceListPresentation {
  if (listCount === 0) return 'hidden';
  if (listCount === 1 && !hasActiveSelection) return 'hidden';
  return listCount + 1 <= chipOptionLimit ? 'chips' : 'picker';
}

/**
 * El bloque «Resumen del cobro» / la fila Faltan–Vuelto solo aparecen cuando
 * hay algo que informar: monto distinto del total, pendiente, vuelto o pago
 * mixto. Tres filas de $0 son ruido permanente.
 */
export function hasCheckoutPaymentProgress(params: {
  draftCount: number;
  saldoPendiente: number;
  vuelto: number;
  totalIngresado: number;
  total: number;
}): boolean {
  const { draftCount, saldoPendiente, vuelto, totalIngresado, total } = params;
  return (
    draftCount > 1 ||
    saldoPendiente > 0 ||
    vuelto > 0 ||
    Math.abs(totalIngresado - total) > 0.005
  );
}
